import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import { productRankingCrumb } from 'utils/breadcrumbInfo';
import { getProductRanking } from 'actions/ReportsAction';
import { getProductCategories } from 'actions/EntityActions';
import { clearFormInput, formInput } from 'actions/FormActions';
// Basic Components
import CardSimple from 'screens/components/basic/CardSimple';
import Pagination from 'screens/components/basic/Pagination';
import PageHeader from 'screens/components/basic/PageHeader';
import Grid from 'screens/components/basic/Grid';

import Body from './Body';
import Header from './Header';

class ProductRankingReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageNumber: 1,
            showBody: false,
            itemsPerPage: 20,
        };
        this.getProductRankingReport = this.getProductRankingReport.bind(this)
    }

    componentWillReceiveProps(newProps) {
        if (this.props.baseStoreResult !== newProps.baseStoreResult && newProps.baseStoreResult != undefined) {
            this.setState({ ...this.state, showBody: true })
        }

    }

    componentWillMount() {
        const date = new Date()
        this.props.getProductCategories(this.props.branchId || parseInt(localStorage.getItem('TECHPOS_SELECTED_BRANCH')));
        this.props.formInput(0, "ProductRankingCategoryOption")
        this.props.clearFormInput("baseStoreSelectedRows");
        this.props.clearFormInput("storeToCompareSelectedRows");
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `ProductRankingFromDate`)
        this.props.formInput(date, `ProductRankingToDate`)
    }


    getCategoryOptions = () => {

        return (this.props.category.list || []).map(item => {
            return {
                text: item.name,
                value: item.id.toString()
            };
        });
    }

    getProductRankingReport() {
        console.log("page");
        console.log(this.state.pageNumber);
        let fromBranch = this.props.brachOptions[this.props.baseStore[0]].value;
        let ToBranch = this.props.storeToCompare.map(item => {
            return ~~this.props.brachOptions[item].value
        })
        let beginDate = this.props.productRankingFromDate ? moment(this.props.productRankingFromDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.productRankingToDate ? moment(this.props.productRankingToDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let model = {
            beginDate: beginDate,
            endDate: endDate,
            baseStore: fromBranch,
            category: this.props.productRankingCategory,
            compareTo: ToBranch.toString(),
            pageNumber: this.state.pageNumber
        }
        this.props.getProductRanking(model)
    }

    changePage = (page) => {
        this.setState({ ...this.state, pageNumber: page }, () => { this.getProductRankingReport() });
    }

    render() {

        return (
            <Grid headerContent={productRankingCrumb}>
                <PageHeader title={LOOKUP.report.productRakingReport.text}
                    description={LOOKUP.report.productRakingReport.description}
                />
                <Header
                    branchOptions={this.props.brachOptions}
                    productCategories={this.getCategoryOptions()}
                    showBody={this.getProductRankingReport}
                />
                {
                    this.state.showBody &&
                    <p className="text-right mt-2">
                        <i>Generated on : {moment().format('MMMM Do YYYY, h:mm:ss a')}</i>
                    </p>
                }
                {
                    this.state.showBody &&
                    <CardSimple>
                        <Body
                            baseStore={this.props.baseStoreResult}
                            compareTo={this.props.compareToResult}
                            branches={this.props.brachOptions}
                        />
                        <Pagination
                            length={this.props.totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.pageNumber}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );

    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })

    return {
        brachOptions: brachOptions,
        category: state.entity.productCategories,
        baseStore: state.form.baseStoreSelectedRows,
        storeToCompare: state.form.storeToCompareSelectedRows,
        productRankingFromDate: state.form.ProductRankingFromDate,
        productRankingToDate: state.form.ProductRankingToDate,
        productRankingCategory: state.form.ProductRankingCategoryOption,
        baseStoreResult: state.reports.baseStore || [],
        compareToResult: state.reports.compareTo,
        totalRow: state.reports.totalRow
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getProductCategories: (branchId) => dispatch(getProductCategories(branchId)),
        getProductRanking: model => dispatch(getProductRanking(model)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductRankingReport);